module.exports = __webpack_public_path__ + "img/Fuel.0e494a22.png";